@let ec = store.ecSg();
@let origin = originSg();
@let isCellContentWrapped = store.isCellContentWrappedSg() ?? false;
@let attributes =
  ec?.plugins?.attributePlugin?.feature?.selectors?.attributes?.asSignal() ??
  [];

<atn-ds-attached-overlay
  [origin]="origin"
  (backdropClick)="store.patchState({ columnSettingsIsOpen: false })"
>
  <div class="atn-ds-table-settings">
    <div
      class="atn-ds-table-settings__item atn-ds-table-settings__item--toggle"
    >
      <atn-ds-toggle-button
        label="Wrap Overflow"
        [active]="isCellContentWrapped"
        (activeChange)="cellContentTogglerHandler($event)"
      >
      </atn-ds-toggle-button>
    </div>
    <div
      cdkDropList
      (cdkDropListDropped)="elementDropHandler($event)"
      class="atn-ds-table-settings__items"
    >
      @for (attribute of attributes; track $index) {
        <div
          class="atn-ds-table-settings__item"
          cdkDrag
        >
          <atn-ds-checkbox
            [label]="attribute.name"
            [selected]="!attribute.isHidden"
            (selectedChange)="
              attributeVisibilityChangeHandler($event, attribute)
            "
          >
          </atn-ds-checkbox>
        </div>
      }
    </div>
  </div>
</atn-ds-attached-overlay>
